<template>
  <div class="change-transaction-category-summary-popup">
    <popup :title="'ההוצאה תעבור'"
           :buttons="buttonOptions"
           :back-action="back">
      <template v-slot:content>
        <change-category-path :old-category="originalCategory" :new-category="selectedCategory" />
        <transaction-details :transaction="transaction" />
        <div v-if="isEnrichByBusinessName" class="explanation" :class="selectedCategory.cashflowCategory">{{ explanation }}</div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import ChangeTransactionCategorySettingsPopup from './ChangeTransactionCategorySettingsPopup.vue';
import TransactionDetails from './TransactionDetails.vue';
import ChangeCategoryPath from './ChangeCategoryPath.vue';
import EventBus from '../../../../../../../../../../event-bus/event-bus';
import Segment from '../../../../../../../../../../Segment';
import cashflowViewConsts from '../../../../../../../../../../constants/cashflow-view';

export default {
  name: 'ChangeTransactionCategorySummaryPopup',
  components: {
    Popup: BaseUI.Popup,
    TransactionDetails,
    ChangeCategoryPath,
  },
  created() {
    Segment.trackUserInteraction('ChangeTransactionCategorySummaryPopup_Shown', { businessName: this.transaction.businessName });
  },
  computed: {
    ...mapState('editTransaction', ['transaction', 'categoryRuleType']),
    ...mapGetters('editTransaction', ['selectedCategory', 'originalCategory', 'ENRICHMENT_INPUT_TYPES', 'categoryToVariant', 'valueForPredicate']),
    isEnrichByBusinessName() {
      return this.categoryRuleType === this.ENRICHMENT_INPUT_TYPES.BUSINESS_NAME;
    },
    explanation() {
      return `כל ההוצאות מ"${this.transaction.businessName}" יופיעו ב${this.selectedCategory.pluralLabel}`;
    },
    buttonOptions() {
      return [{
        title: 'אישור',
        action: this.onSave,
        variant: this.categoryToVariant[this.selectedCategory.cashflowCategory],
      }];
    },
  },
  methods: {
    ...mapActions('editCashflow', ['changeTransactionCategoryOld', 'changeTransactionCategory', 'moveFromTrackingToExpense']),
    back() {
      Segment.trackUserInteraction('ChangeTransactionCategorySummaryPopup_BackClicked', {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategorySettingsPopup,
        props: {},
      });
    },
    async onSave() {
      Segment.trackUserInteraction('ChangeTransactionCategorySummaryPopup_ConfirmClicked', {
        businessName: this.transaction.businessName,
        originalCategory: this.transaction.expense,
        selectedCategory: this.selectedCategory.expense,
        applyTo: this.categoryRuleType,
      });
      this.$emit('close');
      const moveFromRecurring = this.originalCategory.cashflowCategory === cashflowViewConsts.CASHFLOW_CATEGORIES.RECURRING;
      const moveToTracking = this.selectedCategory.cashflowCategory === cashflowViewConsts.CASHFLOW_CATEGORIES.TRACKING;
      const moveFromTracking = this.originalCategory.cashflowCategory === cashflowViewConsts.CASHFLOW_CATEGORIES.TRACKING;
      const moveToVariableOrRecurring = _.includes(
        [cashflowViewConsts.CASHFLOW_CATEGORIES.VARIABLE, cashflowViewConsts.CASHFLOW_CATEGORIES.RECURRING],
        this.selectedCategory.cashflowCategory,
      );
      if (moveFromRecurring && moveToTracking) {
        await this.changeTransactionCategoryOld({
          transaction: this.transaction,
          expense: 'משתנות',
          applyTo: this.categoryRuleType,
        });
        await this.changeTransactionCategory({
          transaction: this.transaction,
          trackingCategoryId: this.selectedCategory.categoryId,
          matchBy: this.categoryRuleType,
          value: this.valueForPredicate,
        });
      } else if (moveToTracking) {
        await this.changeTransactionCategory({
          transaction: this.transaction,
          trackingCategoryId: this.selectedCategory.categoryId,
          matchBy: this.categoryRuleType,
          value: this.valueForPredicate,
        });
      } else if (moveFromTracking && moveToVariableOrRecurring) {
        await this.moveFromTrackingToExpense({
          transaction: this.transaction,
          expense: this.selectedCategory.expense,
          matchBy: this.categoryRuleType,
          value: this.valueForPredicate,
        });
      } else {
        await this.changeTransactionCategoryOld({
          transaction: this.transaction,
          expense: this.selectedCategory.expense,
          applyTo: this.categoryRuleType,
        });
      }

      EventBus.$emit('expand-category', {
        categoryToExpand: this.selectedCategory.expense,
        transactionId: this.transaction.transactionId,
      });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .change-transaction-category-summary-popup {

    .change-category-path {
      margin-bottom: 40px;
    }

    .transaction-details {
      margin-bottom: 24px;
    }

    .explanation {
      font-weight: bold;
      line-height: 16px;

      @include category-color;
    }
  }

</style>
